import { toBoolean } from 'utils/helpers'

export const toApproveTruckPayload = (item, values) => {
  const depositDocumentList = values.depositDocumentList.map(item => ({
    ...item,
    hasNotice: toBoolean(item.hasNotice) || null,
    hasTransportNote: toBoolean(item.hasTransportNote) || null
  }))

  const sealList = values.sealList.map(item => ({ ...item, integral: toBoolean(item.integral) }))

  return {
    id: +item.value,
    ...values,
    depositDocumentList,
    sealList,
    thermodiagramConform: toBoolean(values.thermodiagramConform) ?? null
  }
}
